<template lang="html">
  <div class="serve_introduce">
    <div class="bright" v-if="product.spuDesc">
      <div class="serve_introduce_title pf-medium">亮点介绍</div>
      <div class="bright_detail">{{ product.spuDesc }}</div>
    </div>

    <div v-if="isCourse" class="course">
      <div class="serve_introduce_title pf-medium">课程安排</div>
      <div class="course_item" v-for="(item, index) in courseData" :key="index">
        <div class="name">{{ item.name }}</div>
        <div>{{ item.value }}</div>
      </div>
    </div>

    <div class="image_text" v-if="product.content">
      <div class="serve_introduce_title pf-medium">图文详情</div>
      <div class="pDetail" v-xhtml="product.content"></div>
    </div>
  </div>
</template>

<script>
import PRODUCT_TYPE from './config'
export default {
  mounted() {},
  props: {
    product: {
      type: Object
    }
  },
  computed: {
    //是否是班课
    isCourse() {
      return (
        +this.product.spuType === PRODUCT_TYPE.COURSE_OFFLINE ||
        +this.product.spuType === PRODUCT_TYPE.COURSE_ONE_ON_ONE
      )
    },
    courseData() {
      const { cmmdtyTemplateAttrs = {} } = this.product
      const { numberOfClasses, timeOfClasses, isAuditions } =
        cmmdtyTemplateAttrs
      return [
        { name: '总课时', value: `${numberOfClasses}节` },
        { name: '课程时长', value: `${timeOfClasses}分钟/节` },
        { name: '课程试听', value: `${+isAuditions === 1 ? '提供' : '无'}` }
      ]
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~@/assets/css/mixin';
.serve_introduce {
  padding: rem(30px);
  background: white;

  .serve_introduce_title {
    font-size: rem(28px);
    color: #121212;
    padding-bottom: rem(24px);
  }
  .bright {
    margin-bottom: rem(48px);
    .bright_title {
      font-size: rem(28px);
      padding-bottom: rem(16px);
    }
    &_detail {
      font-size: rem(26px);
      color: #262626;
      word-break: break-all;
      white-space: pre-wrap;
    }
  }
  .course {
    margin-bottom: rem(48px);
    .course_item {
      display: flex;
      align-items: center;
      margin-bottom: rem(20px);
      .name {
        font-size: rem(26px);
        color: #666666;
        min-width: rem(160px);
      }
      div {
        font-size: rem(26px);
        color: #262626;
      }
      &:last-child {
        margin-bottom: 0;
      }
    }
  }

  .image_text {
    .pDetail {
      width: 100%;
      // text-align: center;
      overflow: hidden;

      img {
        max-width: 100%;
      }
    }
  }
}
</style>
